import React from "react";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatError, formatRupiah } from "@/lib/api";
import StatusBadge from "@/components/StatusBadge";

export default function TopUp() {
  const [amount, setAmount] = useState(10);
  const [method, setMethod] = useState("bank_transfer");
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = () => api.get("/deposit/mine").then((r) => setHistory(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/deposit/topup", { amount: Number(amount), method });
      toast.success("Permintaan top up dibuat. Menunggu konfirmasi admin.");
      load();
    } catch (err) {
      toast.error(formatError(err));
    } finally {
      setLoading(false);
    }
  };

  const presets = [10, 25, 50, 100, 250, 500];

  return (
    <div className="max-w-5xl mx-auto px-4 md:px-8 py-10" data-testid="topup-page">
      <div className="label-mono text-zinc-500">// DEPOSIT</div>
      <h1 className="font-display text-4xl md:text-5xl font-black uppercase mt-1">Top Up Saldo</h1>

      <div className="mt-8 grid lg:grid-cols-2 gap-6">
        <form onSubmit={submit} className="border border-black bg-white p-6 shadow-brutal">
          <div className="label-mono text-zinc-500">// FORM</div>
          <h2 className="font-display text-xl font-black uppercase mt-1 mb-4">Permintaan Top Up</h2>

          <label className="label-mono block mb-2">Nominal ($)</label>
          <div className="grid grid-cols-3 gap-2 mb-3">
            {presets.map((p) => (
              <button key={p} type="button" onClick={() => setAmount(p)} className={`border border-black px-3 py-2 font-mono text-xs font-bold ${amount === p ? "bg-black text-white" : "hover:bg-zinc-100"}`} data-testid={`topup-preset-${p}`}>
                {formatRupiah(p)}
              </button>
            ))}
          </div>
          <input type="number" min={1} step={0.01} value={amount} onChange={(e) => setAmount(parseFloat(e.target.value) || 0)} className="input-brutal mb-4" data-testid="topup-amount" />

          <label className="label-mono block mb-2">Metode</label>
          <select value={method} onChange={(e) => setMethod(e.target.value)} className="input-brutal mb-6" data-testid="topup-method">
            <option value="bank_transfer">Bank Transfer / Wise</option>
            <option value="ewallet">E-Wallet / PayPal</option>
          </select>

  

          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="topup-submit">
            {loading ? "// PROCESSING..." : "Buat Permintaan →"}
          </button>
        </form>

        <div className="border border-black bg-white">
          <div className="p-4 border-b border-black label-mono">// HISTORY</div>
          {history.length === 0 ? (
            <div className="p-8 text-center font-mono text-xs text-zinc-500">// Belum ada riwayat</div>
          ) : (
            history.map((h) => (
              <div key={h.id} className="p-4 border-b border-zinc-200 flex justify-between items-center" data-testid={`topup-history-${h.id}`}>
                <div>
                  <div className="font-mono text-sm font-bold">{formatRupiah(h.amount)}</div>
                  <div className="text-xs text-zinc-600 font-mono mt-1">{new Date(h.created_at).toLocaleString("en-US")} · {h.method}</div>
                </div>
                <StatusBadge status={h.status} />
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

